export const test_data = {
  english: {
    invalidImage: {
      session_id: "b6bc3250-871e-45ca-83b4-128407e2bf51",
      message: '[{"text":"Invalid image"}]',
      element: {},
      inputType: "invalidimage",
      loginStatus: "401",
    },
    uds: {
      session_id: "f14cf64d-92cc-404f-a222-794d469464d4",
      message: '[{"text":"Please enter request number"}]',
      conv_id: "fc1594fd-a769-4170-805d-26b90812db77",
      chatby: "bot",
      channel: "web",
      action: "",
      timestamp: "var2",
      element: {},
      inputType: "UDS",
      Url: "http://localhost:8020/SECApplication-phase3/",
      language: "en",
    },
    faqLink: {
      session_id: "fac99a18-a9de-4683-a474-5191318e5839",
      message:
        '[{"text":"Please enter your valid inquiry so we can provide the necessary support more effectively, for more information you can check the <Link>FAQs</Link>"}]',
      conv_id: "f87b343c-605c-4afc-aca0-d3cfa5b49547",
      chatby: "bot",
      channel: "web",
      action: "",
      timestamp: "var2",
      element: {},
      inputType: "",
      Url: "https://sec-chatbot.se.com.sa/",
      language: "en",
    },
    requestLink: {
      session_id: "d7bc4896-b338-485b-9a6e-280f3cf4bb8e",
      message:
        '[{"text":"\\n Request Status : Completed\\n Request creation time : 2024/01/23 00:00\\n Note : ‫لم يتم الانتهاء من العزل الحراري للجدران‬\\n  <Links>Request</Links>"},{"text":"Would you like to contact our agents?"}]',
      conv_id: "b9f89c8d-d010-4a0e-9ef1-250da9cd5caa",
      chatby: "bot",
      channel: "web",
      ip_address: "10.128.31.201",
      action: "validate_uds_number_P5",
      timestamp: "var2",
      element: {
        Btns: {
          Buttons: [
            {
              name: "Exit",
              value: "Exit",
            },
            {
              name: "Start the conversation",
              value: "Start the conversation",
              Values: [
                {
                  name: "full_name",
                },
                {
                  name: "mobile_number",
                },
                {
                  name: "contract_number",
                },
                {
                  name: "chat_transcript",
                  value:
                    " \nCustomer: {anonymous} \nBot:  Let's start, How can I help you? \nCustomer: Track Requests \nBot:  Choose the service \nCustomer: Electricity Connection Request \nBot:  Please enter request number \nCustomer: 242000036",
                },
              ],
            },
          ],
        },
      },
      inputType: "Agent",
      Url: "https://slstage.sec.se.com.sa/",
      language: "en",
      bp_number: "var1",
      newPhone: false,
      freeText: false,
    },
    agent: {
      session_id: "6427fcfe-fcce-4fc1-892a-4e84b5374d70",
      message: '[{"text":"Get in touch with the agent"}]',
      conv_id: "77c61263-8ade-4bdf-8589-21a3c802847e",
      chatby: "bot",
      channel: "web",
      action: "verify_otp",
      timestamp: "var2",
      element: {
        userParam: {
          Values: [
            {
              name: "full_name",
            },
            {
              name: "mobile_number",
              value: "0540554215",
            },
            {
              name: "contract_number",
              value: "30031350787",
            },
            {
              name: "chat_transcript",
              value:
                " \nCustomer: {anonymous} \nBot:  Let's start, How can I help you? \nCustomer: Agent Support \nBot:  Please select the type of service \nCustomer: Inquiries and Complaints \nBot:  Select the entry option \nCustomer: Account Number \nBot:  Please enter account number \nCustomer: 30031350787 \nBot:  Please enter the OTP that was sent to you. \nCustomer: 7663",
            },
            {
              name: "entryPointId",
              value: "1010",
            },
            {
              name: "templateName",
              value: "Cbot_En",
            },
            {
              name: "locale",
              value: "en-US",
            },
          ],
        },
      },
      inputType: "",
      Url: "https://slstage.sec.se.com.sa/",
      language: "en",
    },
    upload: {
      session_id: "be750eeb-6923-4608-9d04-7117d1e411d2",
      message: '[{"text":"Attach a picture for the report"}]',
      conv_id: "9945431f-f01c-43b7-aa32-12d6d99caa0a",
      chatby: "bot",
      channel: "web",
      ip_address: "10.128.31.201",
      action: "",
      timestamp:
        "iip/Xl6I/iPXO/0usVaq6bVJqJZGeOUHgh+8ZUwoQZyJPLkw3Fo8abNYqIleYa/q",
      element: {
        Btns: {
          Buttons: [
            {
              name: "Attach the picture",
              value: "Attach the picture",
            },
          ],
        },
      },
      inputType: "File",
      Url: "https://slstage.sec.se.com.sa/",
      language: "en",
      bp_number: "CzU1lM1yJtxv8ZQfn8GOq7OPrLYpfUPRQGjl0is1Svk=",
      newPhone: false,
      freeText: false,
    },
    loaction: {
      session_id: "be750eeb-6923-4608-9d04-7117d1e411d2",
      message: '[{"text":"Please share the location"}]',
      conv_id: "9945431f-f01c-43b7-aa32-12d6d99caa0a",
      chatby: "bot",
      channel: "web",
      ip_address: "10.128.31.201",
      action: "",
      timestamp:
        "iip/Xl6I/iPXO/0usVaq6bVJqJZGeOUHgh+8ZUwoQZyJPLkw3Fo8abNYqIleYa/q",
      element: {
        Btns: {
          Buttons: [
            {
              name: "Share your location",
              value: "Share your location",
            },
          ],
        },
      },
      inputType: "Location",
      Url: "https://slstage.sec.se.com.sa/",
      language: "en",
      bp_number: "CzU1lM1yJtxv8ZQfn8GOq7OPrLYpfUPRQGjl0is1Svk=",
      newPhone: false,
      freeText: false,
    },
    cardWithname: {
      session_id: "dcde7b79-86c5-4819-b083-e026dfe12692",
      message:
        '[{"text":"Please find the details as below :"},{"text":"We hope that we diligently serviced you, share your evaluation with us.\\nHave a nice day!"}]',
      conv_id: "0cb17cff-1845-482d-969f-92fd5f660b15",
      chatby: "bot",
      channel: "web",
      ip_address: "10.128.31.201",
      action: "get_account_information",
      timestamp: "var2",
      element: {
        AccNameParam: {
          Values: [
            {
              name: "contract_number",
              value: "30050740945",
            },
            {
              name: "property_name",
              value: "أبو خالد",
              // value: "أبو خالد  2أبو خالد أبو خالد",
              // value: "أبو خالد أبو خالد أبو خالد أبو خالد",
              // value: "أبو خالد أبو أبو خالد أبو خالد أبو خالد أبو خالد",
              // value: "We hope that we diligently serviced you",
            },
            {
              name: "meter_number",
              value: "LYE2020830015321",
            },
            {
              name: "role",
              value: "Owner",
            },
          ],
        },
        feedbackBtn: {
          options: [
            {
              name: "Very satisfied",
              value: "5",
            },
            {
              name: "Satisfied",
              value: "4",
            },
            {
              name: "Netural",
              value: "3",
            },
            {
              name: "Dissatisfied",
              value: "2",
            },
            {
              name: "Very dissatisfied",
              value: "1",
            },
          ],
        },
      },
      inputType: "AccountInfoWithName",
      Url: "https://sec-chatbot-uat.sec.se.com.sa/SECApplication/",
      language: "en",
      bp_number: "var1",
      newPhone: false,
      freeText: false,
    },
    billInfo: {
      session_id: "f578c593-9767-4c0b-8342-a695e984047f",
      message:
        '[{"text":"To review the bill details, click on the attachment"},{"text":"We are pleased to serve you, how would you rate your experience with Chatbot?"}]',
      conv_id: "f8403c02-a580-4be4-b1e3-d6d0e5b4d7bf",
      chatby: "bot",
      channel: "web",
      action: "bill_status",
      timestamp: "var2",
      element: {
        BillParam: {
          Values: [
            {
              name: "contract_number",
              value: "30043561981",
            },
            {
              name: "total_amount",
              value: "290.43",
            },
          ],
        },
        feedbackBtn: {
          options: [
            {
              name: "Completely Satisfied",
              value: "5",
            },
            {
              name: "Satisfied",
              value: "4",
            },
            {
              name: "Netural",
              value: "3",
            },
            {
              name: "Unsatisfied",
              value: "2",
            },
            {
              name: "Completely unsatisfied",
              value: "1",
            },
          ],
        },
      },
      inputType: "BillInfo",
      Url: "https://sec-chatbot.se.com.sa/",
      language: "en",
    },
    phone: {
      session_id: "43005358-36c1-418f-9dd7-8be016280251",
      message: '[{"text":"Dear customer, enter your phone number."}]',
      conv_id: "f71dbcbf-cdc6-4412-9988-1f8b32674860",
      chatby: "bot",
      channel: "web",
      ip_address: "10.128.31.201",
      action: "",
      timestamp: "var2",
      element: {},
      inputType: "Phone",
      Url: "https://slstage.sec.se.com.sa/",
      language: "en",
      bp_number: "var1",
      newPhone: false,
      freeText: false,
    },
    otp: {
      session_id: "a7e8a40b-5ae0-4c5d-bc2e-95d1ce29fef6",
      message: '[{"text":"Please enter verification code"}]',
      conv_id: "00c90ee4-f480-46bb-9b95-cfaf01d2828b",
      chatby: "bot",
      channel: "web",
      ip_address: "10.128.31.201",
      action: "send_otp",
      timestamp: "var2",
      element: {
        Btns: {
          Buttons: [
            {
              name: "Resend verification code",
              value: "Resend verification code",
            },
          ],
        },
      },
      inputType: "OTP",
      Url: "https://sec-chatbot-uat.sec.se.com.sa/",
      language: "en",
      bp_number: "var1",
      newPhone: false,
      freeText: false,
    },
    main_menu: {
      session_id: "8e342ff3-498e-4dd7-a1e5-24842962ecc3",
      message: '[{"text":"Let\'s start."},{"text":"How can I help you?"}]',
      conv_id: "99b744bb-21c9-41e5-a4e8-4d4a99c2939f",
      chatby: "bot",
      channel: "web",
      ip_address: "10.128.31.201",
      action: "",
      timestamp: "var2",
      element: {
        Btns: {
          Buttons: [
            {
              name: "Accounts & Bills",
              value: "Accounts & Bills",
            },
            {
              name: "Report an Outage",
              value: "Report an Outage",
            },
            {
              name: "Track Requests",
              value: "Track Requests",
            },
            {
              name: "Safety Services",
              value: "Safety Services",
            },
            {
              name: "Agent Support",
              value: "Agent Support",
            },
          ],
        },
      },
      inputType: "Mainmenu",
      Url: "https://slstage.sec.se.com.sa/",
      language: "en",
      bp_number: "var1",
      newPhone: false,
      freeText: false,
    },
    account_bills: {
      session_id: "13ad71f8-f011-4b7b-8e48-66c788e16721",
      message: '[{"text":"Choose the service"}]',
      conv_id: "92079cae-4b9a-49b8-9f70-08cba7502a0b",
      chatby: "bot",
      channel: "web",
      ip_address: "10.128.31.201",
      action: "validate_contract_account_P3",
      timestamp: "var2",
      element: {
        Btns: {
          Buttons: [
            {
              name: "Account Information",
              value: "Account Information",
            },
            {
              name: "Bill Information",
              value: "Bill Information",
            },
            {
              name: "Fixed Bill",
              value: "Fixed Bill",
            },
          ],
        },
      },
      inputType: "Submenu",
      Url: "https://slstage.sec.se.com.sa/",
      language: "en",
      bp_number: "var1",
      newPhone: false,
      freeText: false,
    },
    report_outage: {
      session_id: "159b0ba0-3318-4d4b-a622-42328b439c0e",
      message: '[{"text":"Please select the type of report"}]',
      conv_id: "23d1b3a8-7457-49c4-a8c6-b97b0774041e",
      chatby: "bot",
      channel: "web",
      ip_address: "10.128.31.201",
      action: "verify_otp",
      timestamp: "var2",
      element: {
        Btns: {
          Buttons: [
            {
              name: "Due to a fire",
              value: "Due to a fire",
            },
            {
              name: "Complete",
              value: "Complete",
            },
            {
              name: "Partial",
              value: "Partial",
            },
            {
              name: "Voltage Problem",
              value: "Voltage Problem",
            },
          ],
        },
      },
      inputType: "Submenu",
      Url: "https://slstage.sec.se.com.sa/",
      language: "en",
      bp_number: "var1",
      newPhone: false,
      freeText: false,
    },
    track_request: {
      session_id: "159b0ba0-3318-4d4b-a622-42328b439c0e",
      message: '[{"text":"Choose the service"}]',
      conv_id: "23d1b3a8-7457-49c4-a8c6-b97b0774041e",
      chatby: "bot",
      channel: "web",
      ip_address: "10.128.31.201",
      action: "",
      timestamp: "var2",
      element: {
        Btns: {
          Buttons: [
            {
              name: "Report an Outage",
              value: "Report an Outage",
            },
            {
              name: "Electricity Connection Request",
              value: "Electricity Connection Request",
            },
            {
              name: "Tickets & Requests",
              value: "Tickets & Requests",
            },
          ],
        },
      },
      inputType: "Submenu",
      Url: "https://slstage.sec.se.com.sa/",
      language: "en",
      bp_number: "var1",
      newPhone: false,
      freeText: false,
    },
    safty_services: {
      session_id: "159b0ba0-3318-4d4b-a622-42328b439c0e",
      message: '[{"text":"Choose the service"}]',
      conv_id: "23d1b3a8-7457-49c4-a8c6-b97b0774041e",
      chatby: "bot",
      channel: "web",
      ip_address: "10.128.31.201",
      action: "",
      timestamp: "var2",
      element: {
        Btns: {
          Buttons: [
            {
              name: "Alkahraba Friend",
              value: "Alkahraba Friend",
            },
            {
              name: "Aamin",
              value: "Aamin",
            },
          ],
        },
      },
      inputType: "Submenu",
      Url: "https://slstage.sec.se.com.sa/",
      language: "en",
      bp_number: "var1",
      newPhone: false,
      freeText: false,
    },
    agent_support: {
      session_id: "159b0ba0-3318-4d4b-a622-42328b439c0e",
      message: '[{"text":"How can I help you today?"}]',
      conv_id: "23d1b3a8-7457-49c4-a8c6-b97b0774041e",
      chatby: "bot",
      channel: "web",
      ip_address: "10.128.31.201",
      action: "",
      timestamp: "var2",
      element: {
        Btns: {
          Buttons: [
            {
              name: "Report an outage",
              value: "Report an outage",
            },
            {
              name: "Inquiries and Complaints",
              value: "Inquiries and Complaints",
            },
          ],
        },
      },
      inputType: "Submenu",
      Url: "https://slstage.sec.se.com.sa/",
      language: "en",
      bp_number: "var1",
      newPhone: false,
      freeText: false,
    },
    inquiry_complaints: {
      session_id: "159b0ba0-3318-4d4b-a622-42328b439c0e",
      message: '[{"text":"Select the entry option"}]',
      conv_id: "23d1b3a8-7457-49c4-a8c6-b97b0774041e",
      chatby: "bot",
      channel: "web",
      ip_address: "10.128.31.201",
      action: "",
      timestamp: "var2",
      element: {
        Btns: {
          Buttons: [
            {
              name: "Account Number",
              value: "Account Number",
            },
            {
              name: "Request Number",
              value: "Request Number",
            },
            {
              name: "Mobile Number",
              value: "Mobile Number",
            },
          ],
        },
      },
      inputType: "Submenu",
      Url: "https://slstage.sec.se.com.sa/",
      language: "en",
      bp_number: "var1",
      newPhone: false,
      freeText: false,
    },
    dropdown_list: {
      session_id: "47acb775-17f3-47fc-9739-0d4598bbbc7d",
      message:
        '[{"text":"Please select the contract account number from the drop-down. "}]',
      conv_id: "a3065c85-7eb3-42a4-b65d-ba250fa01129",
      chatby: "bot",
      channel: "web",
      ip_address: "10.128.31.201",
      action: "get_contract_accounts_2",
      timestamp:
        "Pzagtrdu9FvjG5XzsmRIvg/C5c6NpyfZQc5cjdwxd9zhTJnQW4N87F0BVO5iBeyK",
      element: {
        dropdown: {
          options: [
            {
              name: "30043599988",
              value: "30043599988",
            },
            {
              name: "30043599997",
              value: "30043599997",
            },
            {
              name: "30052842185",
              value: "30052842185",
            },
            {
              name: "30043569002",
              value: "30043569002",
            },
            {
              name: "30043561981",
              value: "30043561981",
              nickname: "الوالدة السكن 1",
            },
            {
              name: "30043561720",
              value: "30043561720",
              nickname: "الوالدة دار الحكمة 2",
            },
            {
              name: "30033558758",
              value: "30033558758",
              nickname: "السليمانية 23 الخدمات",
            },
            {
              name: "30056344421",
              value: "30056344421",
            },
            {
              name: "30055055657",
              value: "30055055657",
              nickname: "هوم ريزدنس B الدور الثاني",
            },
            {
              name: "30055056574",
              value: "30055056574",
              nickname: "اختبار test للاسم",
            },
            {
              name: "30000286359",
              value: "30000286359",
              nickname: "Updated nickname with long char to check ui",
            },
            {
              name: "30043561720",
              value: "30043561720",
              nickname: "الوالدة دار الحكمة 2",
            },
            {
              name: "30033558758",
              value: "30033558758",
              nickname: "السليمانية 23 الخدمات",
            },
            {
              name: "30056344421",
              value: "30056344421",
            },
            {
              name: "30055055657",
              value: "30055055657",
              nickname: "هوم ريزدنس B الدور الثاني",
            },
            {
              name: "30055056574",
              value: "30055056574",
              nickname: "اختبار test للاسم",
            },
            {
              name: "30000286359",
              value: "30000286359",
              nickname: "Updated nickname with long char to check ui",
            },
            {
              name: "30043561720",
              value: "30043561720",
              nickname: "الوالدة دار الحكمة 2",
            },
            {
              name: "30033558758",
              value: "30033558758",
              nickname: "السليمانية 23 الخدمات",
            },
            {
              name: "30056344421",
              value: "30056344421",
            },
            {
              name: "30055055657",
              value: "30055055657",
              nickname: "هوم ريزدنس B الدور الثاني",
            },
            {
              name: "30055056574",
              value: "30055056574",
              nickname: "اختبار test للاسم",
            },
            {
              name: "30000286359",
              value: "30000286359",
              nickname: "Updated nickname with long char to check ui",
            },
            {
              name: "30043561720",
              value: "30043561720",
              nickname: "الوالدة دار الحكمة 2",
            },
            {
              name: "30033558758",
              value: "30033558758",
              nickname: "السليمانية 23 الخدمات",
            },
            {
              name: "30056344421",
              value: "30056344421",
            },
            {
              name: "30055055657",
              value: "30055055657",
              nickname: "هوم ريزدنس B الدور الثاني",
            },
            {
              name: "30055056574",
              value: "30055056574",
              nickname: "اختبار test للاسم",
            },
            {
              name: "30000286359",
              value: "30000286359",
              nickname: "Updated nickname with long char to check ui",
            },
          ],
        },
      },
      inputType: "Account",
      Url: "https://slstage.sec.se.com.sa/",
      language: "en",
      bp_number: "xQPSzXOsp22yQPjauXQV7C3tf8Wtzj1Se4SZZErhUGA=",
      newPhone: false,
      freeText: false,
    },
    lastMessage: {
      session_id: "e3378d88-64d3-4cba-8e5f-e96fca036c41",
      message:
        '[{"text":"Thank you, Your feedback helps us improve our services."}]',
      conv_id: "13fa086b-e203-44fd-83df-d4bf1a3d6738",
      chatby: "bot",
      channel: "web",
      action: "connect2survey",
      timestamp: "var2",
      element: {
        Btns: {
          Buttons: [
            {
              name: "Back to Main Menu",
              value: "Back to Main Menu",
            },
          ],
        },
      },
      inputType: "lastMessage",
      Url: "https://slstage.sec.se.com.sa/",
      language: "en",
    },
    otherBtn: {
      session_id: "90482e7e-d3f5-4b12-ac0f-fe342bba3451",
      message: '[{"text":"Please Choose the type"}]',
      conv_id: "c9fe61a2-1c6d-4b05-8660-f8561ac7c014",
      chatby: "bot",
      channel: "web",
      action: "",
      timestamp:
        "LM/JtilO31UXC66hlv46m1oELekUXPGr15iiMftqvmVbIS/idt6k7xPLVzY2wtQ2",
      element: {
        Btns: {
          Buttons: [
            {
              name: "Unsafe electrical equipment",
              value: "Unsafe electrical equipment",
            },
            {
              name: "Danger/Incomplete digs",
              value: "Danger/Incomplete digs",
            },
            {
              name: "Agents fail to meet safety standards",
              value: "Agents fail to meet safety standards",
            },
            {
              name: "Other",
              value: "Other",
            },
          ],
        },
      },
      inputType: "",
      Url: "https://slstage.sec.se.com.sa/",
      language: "en",
    },
  },
  arabic: {
    uds: {},
    faqLink: {},
    requestLink: {
      session_id: "f980cf55-dc62-4e24-b87f-e1eaf651e412",
      message:
        '[{"text":"</div> \\n حالة الطلب : مكتمل\\n وقت انشاء الطلب : <div class=\'Tnumber\'>23/01/2024 00:00</div>\\n ملاحظة  ‫لم يتم الانتهاء من العزل الحراري للجدران‬\\n <Links> Request</Links>"},{"text":"هل ترغب بالتواصل مع أحد موظفينا؟"}]',
      conv_id: "8a7b80ed-a6b3-4455-8b21-1fa38d7bbda0",
      chatby: "bot",
      channel: "web",
      ip_address: "10.128.31.201",
      action: "validate_uds_number_P5",
      timestamp: "var2",
      element: {
        Btns: {
          Buttons: [
            {
              name: "الخروج",
              value: "الخروج",
            },
            {
              name: "بدء المحادثة",
              value: "بدء المحادثة",
              Values: [
                {
                  name: "full_name",
                },
                {
                  name: "mobile_number",
                },
                {
                  name: "contract_number",
                },
                {
                  name: "chat_transcript",
                  value:
                    "+%0ACustomer%3A+%7Banonymous%7D+%0ABot%3A++%D8%AD%D9%8A%D8%A7%D9%83+%D8%A7%D9%84%D9%84%D9%87%D8%8C+%D9%83%D9%8A%D9%81+%D8%A7%D9%82%D8%AF%D8%B1+%D8%A7%D8%B3%D8%A7%D8%B9%D8%AF%D9%83%D8%9F+%0ACustomer%3A+%D9%85%D8%AA%D8%A7%D8%A8%D8%B9%D8%A9+%D8%A7%D9%84%D8%B7%D9%84%D8%A8%D8%A7%D8%AA+%0ABot%3A++%D8%A7%D8%AE%D8%AA%D8%B1+%D8%A7%D9%84%D8%AE%D8%AF%D9%85%D8%A9+%0ACustomer%3A+%D8%B7%D9%84%D8%A8+%D8%AE%D8%AF%D9%85%D8%A9+%D9%83%D9%87%D8%B1%D8%A8%D8%A7%D8%A6%D9%8A%D8%A9+%0ABot%3A++%D9%8A%D8%B1%D8%AC%D9%89+%D8%A7%D8%AF%D8%AE%D8%A7%D9%84+%D8%B1%D9%82%D9%85+%D8%A7%D9%84%D8%B7%D9%84%D8%A8+%0ACustomer%3A+242000036",
                },
              ],
            },
          ],
        },
      },
      inputType: "Agent",
      Url: "https://slstage.sec.se.com.sa/",
      language: "ar",
      bp_number: "var1",
      newPhone: false,
      freeText: false,
    },
    agent: {},
    upload: {},
    loaction: {},
    cardWithname: {
      session_id: "f6adf2ee-fdcf-47b4-9e27-64ee1c4ac3f7",
      message:
        '[{"text":"لمراجعة تفاصيل الحساب، انقر على المرفق"},{"text":"سعدنا بخدمتك، ما مدى رضاك عن تجربتك مع الخدمة التفاعلية؟"}]',
      conv_id: "c23adb48-22e1-4e47-8454-525107583d4a",
      chatby: "bot",
      channel: "web",
      ip_address: "0:0:0:0:0:0:0:1",
      action: "get_account_information",
      timestamp: "var2",
      element: {
        AccNameParam: {
          Values: [
            {
              name: "contract_number",
              value: "30000286359",
            },
            {
              name: "property_name",
              // value: "Updated nickname with long char to check ui",
              value: "هوم ريزدنس B الدور الثاني",
            },
            {
              name: "meter_number",
              value: "ECC2020807383343",
            },
            {
              name: "role",
              value: "مالك مستفيد",
            },
          ],
        },
        feedbackBtn: {
          options: [
            {
              name: "راضي تماما",
              value: "5",
            },
            {
              name: "راضي",
              value: "4",
            },
            {
              name: "محايد",
              value: "3",
            },
            {
              name: "غير راضي",
              value: "2",
            },
            {
              name: "غير راضي تماما",
              value: "1",
            },
          ],
        },
      },
      inputType: "AccountInfoWithName",
      Url: "http://localhost:8020/SECApplication-phase3/",
      language: "ar",
      bp_number: "var1",
      newPhone: false,
      freeText: false,
    },
    billInfo: {
      session_id: "8e288cd0-41f2-4f68-bfb2-96bcc5c1440f",
      message:
        '[{"text":"يرجى الاطلاع على التفاصيل على النحو التالي :"},{"text":"نتمنى اننا قدمنا الخدمة الأمثل لك، شاركنا\\nتقييمك\\nيومك سعيد!"}]',
      conv_id: "98863e4c-8e87-4567-a088-683ff8254a27",
      chatby: "bot",
      channel: "web",
      ip_address: "10.128.31.201",
      action: "get_account_information",
      timestamp:
        "BmcuNfjMZwv/FGlLRaTE2OXe5wTh40339dJagf/HE5bDsWgCOCIWU6fMSknl1wA3",
      element: {
        BillParam: {
          Values: [
            {
              name: "contract_number",
              value: "30043599997",
            },
            {
              name: "already_paid",
              value: "25.89",
            },
            {
              name: "total_amount",
              value: "35.89",
            },
            {
              name: "remaining_amount",
              value: "10.00",
            },
          ],
        },
        feedbackBtn: {
          options: [
            {
              name: "راضي جداً",
              value: "5",
            },
            {
              name: "راضي",
              value: "4",
            },
            {
              name: "متوسط",
              value: "3",
            },
            {
              name: "غير راضي",
              value: "2",
            },
            {
              name: "غير راضي ابد",
              value: "1",
            },
          ],
        },
      },
      inputType: "BillInfo",
      Url: "https://slstage.sec.se.com.sa/",
      language: "ar",
      bp_number: "HCS3c7pOqL5Cp85X6f+7HA/cx9iGZXKzUUPOoVNPtsg=",
      newPhone: false,
      freeText: false,
    },
    phone: {},
    otp: {
      session_id: "83fe93fc-041e-445c-92b9-018305a7c70c",
      message:
        '[{"text":"أدخل رمز التحقق المكون من 4 أرقام المرسل الى رقم الجوال المنتهي بـ ******7979"}]',
      conv_id: "d52e8e13-0ef5-4dc1-8b83-208047fe4ef8",
      chatby: "bot",
      channel: "web",
      ip_address: "10.128.31.201",
      action: "send_otp",
      timestamp: "var2",
      element: {
        Btns: {
          Buttons: [
            {
              name: "إعادة ارسال رمز التحقق",
              value: "إعادة ارسال رمز التحقق",
            },
          ],
        },
      },
      inputType: "OTP",
      Url: "https://slstage.sec.se.com.sa/",
      language: "ar",
      bp_number: "var1",
      newPhone: false,
      freeText: false,
    },
    main_menu: {
      session_id: "b5522ecd-67d1-4f6c-8b4a-218c7b07481c",
      message: '[{"text":"حياك الله، كيف اقدر اساعدك؟"}]',
      conv_id: "49350a92-de6e-4988-a64a-012ce0416e1f",
      chatby: "bot",
      channel: "web",
      ip_address: "10.128.31.201",
      action: "",
      timestamp: "var2",
      element: {
        Btns: {
          Buttons: [
            {
              name: "الحسابات والفواتير",
              value: "الحسابات والفواتير",
            },
            {
              name: "بلاغ انقطاع الخدمة الكهربائية",
              value: "بلاغ انقطاع الخدمة الكهربائية",
            },
            {
              name: "متابعة الطلبات",
              value: "متابعة الطلبات",
            },
            {
              name: "خدمات لسلامتك",
              value: "خدمات لسلامتك",
            },
            {
              name: "الدعم",
              value: "الدعم",
            },
          ],
        },
      },
      inputType: "Mainmenu",
      Url: "https://slstage.sec.se.com.sa/",
      language: "ar",
      bp_number: "var1",
      newPhone: false,
      freeText: false,
    },
    account_bills: {},
    report_outage: {},
    track_request: {},
    safty_services: {},
    agent_support: {},
    inquiry_complaints: {},
    dropdown_list: {},
    lastMessage: {},
    otherBtn: {},
  },
};

export const test_combined = [
  // {
  //   id: 2,
  //   data: {
  //     ndata: {
  //       session_id: "8e342ff3-498e-4dd7-a1e5-24842962ecc3",
  //       message: '[{"text":"Let\'s start."},{"text":"How can I help you?"}]',
  //       conv_id: "99b744bb-21c9-41e5-a4e8-4d4a99c2939f",
  //       chatby: "bot",
  //       channel: "web",
  //       ip_address: "10.128.31.201",
  //       action: "",
  //       timestamp: "var2",
  //       element: {
  //         Btns: {
  //           Buttons: [
  //             {
  //               name: "Accounts & Bills",
  //               value: "Accounts & Bills",
  //             },
  //             {
  //               name: "Report an Outage",
  //               value: "Report an Outage",
  //             },
  //             {
  //               name: "Track Requests",
  //               value: "Track Requests",
  //             },
  //             {
  //               name: "Safety Services",
  //               value: "Safety Services",
  //             },
  //             {
  //               name: "Agent Support",
  //               value: "Agent Support",
  //             },
  //           ],
  //         },
  //       },
  //       inputType: "Mainmenu",
  //       Url: "https://slstage.sec.se.com.sa/",
  //       language: "en",
  //       bp_number: "var1",
  //       newPhone: false,
  //       freeText: false,
  //     },
  //   },
  // },
  // {
  //   id: 4,
  //   data: {
  //     ndata: {
  //       session_id: "159b0ba0-3318-4d4b-a622-42328b439c0e",
  //       message: '[{"text":"Choose the service"}]',
  //       conv_id: "23d1b3a8-7457-49c4-a8c6-b97b0774041e",
  //       chatby: "bot",
  //       channel: "web",
  //       ip_address: "10.128.31.201",
  //       action: "",
  //       timestamp: "var2",
  //       element: {
  //         Btns: {
  //           Buttons: [
  //             {
  //               name: "Report an Outage",
  //               value: "Report an Outage",
  //             },
  //             {
  //               name: "Electricity Connection Request",
  //               value: "Electricity Connection Request",
  //             },
  //             {
  //               name: "Tickets & Requests",
  //               value: "Tickets & Requests",
  //             },
  //           ],
  //         },
  //       },
  //       inputType: "Submenu",
  //       Url: "https://slstage.sec.se.com.sa/",
  //       language: "en",
  //       bp_number: "var1",
  //       newPhone: false,
  //       freeText: false,
  //     },
  //   },
  // },
  // {
  //   id: 6,
  //   data: {
  //     ndata: {
  //       session_id: "be750eeb-6923-4608-9d04-7117d1e411d2",
  //       message: '[{"text":"Attach a picture for the report"}]',
  //       conv_id: "9945431f-f01c-43b7-aa32-12d6d99caa0a",
  //       chatby: "bot",
  //       channel: "web",
  //       ip_address: "10.128.31.201",
  //       action: "",
  //       timestamp:
  //         "iip/Xl6I/iPXO/0usVaq6bVJqJZGeOUHgh+8ZUwoQZyJPLkw3Fo8abNYqIleYa/q",
  //       element: {
  //         Btns: {
  //           Buttons: [
  //             {
  //               name: "Attach the picture",
  //               value: "Attach the picture",
  //             },
  //           ],
  //         },
  //       },
  //       inputType: "File",
  //       Url: "https://slstage.sec.se.com.sa/",
  //       language: "en",
  //       bp_number: "CzU1lM1yJtxv8ZQfn8GOq7OPrLYpfUPRQGjl0is1Svk=",
  //       newPhone: false,
  //       freeText: false,
  //     },
  //   },
  // },
  // {
  //   id: 8,
  //   data: {
  //     ndata: {
  //       session_id: "47acb775-17f3-47fc-9739-0d4598bbbc7d",
  //       message:
  //         '[{"text":"Please select the contract account number from the drop-down. "}]',
  //       conv_id: "a3065c85-7eb3-42a4-b65d-ba250fa01129",
  //       chatby: "bot",
  //       channel: "web",
  //       ip_address: "10.128.31.201",
  //       action: "get_contract_accounts_2",
  //       timestamp:
  //         "Pzagtrdu9FvjG5XzsmRIvg/C5c6NpyfZQc5cjdwxd9zhTJnQW4N87F0BVO5iBeyK",
  //       element: {
  //         dropdown: {
  //           options: [
  //             {
  //               name: "30043599988",
  //               value: "30043599988",
  //             },
  //             {
  //               name: "30043599997",
  //               value: "30043599997",
  //             },
  //             {
  //               name: "30052842185",
  //               value: "30052842185",
  //             },
  //             {
  //               name: "30043569002",
  //               value: "30043569002",
  //             },
  //             {
  //               name: "30043561981",
  //               value: "30043561981",
  //               nickname: "الوالدة السكن 1",
  //             },
  //             {
  //               name: "30043561720",
  //               value: "30043561720",
  //               nickname: "الوالدة دار الحكمة 2",
  //             },
  //           ],
  //         },
  //       },
  //       inputType: "Account",
  //       Url: "https://slstage.sec.se.com.sa/",
  //       language: "en",
  //       bp_number: "xQPSzXOsp22yQPjauXQV7C3tf8Wtzj1Se4SZZErhUGA=",
  //       newPhone: false,
  //       freeText: false,
  //     },
  //   },
  // },
  // {
  //   id: 10,
  //   data: {
  //     ndata: {
  //       session_id: "be750eeb-6923-4608-9d04-7117d1e411d2",
  //       message: '[{"text":"Please share the location"}]',
  //       conv_id: "9945431f-f01c-43b7-aa32-12d6d99caa0a",
  //       chatby: "bot",
  //       channel: "web",
  //       ip_address: "10.128.31.201",
  //       action: "",
  //       timestamp:
  //         "iip/Xl6I/iPXO/0usVaq6bVJqJZGeOUHgh+8ZUwoQZyJPLkw3Fo8abNYqIleYa/q",
  //       element: {
  //         Btns: {
  //           Buttons: [
  //             {
  //               name: "Share your location",
  //               value: "Share your location",
  //             },
  //           ],
  //         },
  //       },
  //       inputType: "Location",
  //       Url: "https://slstage.sec.se.com.sa/",
  //       language: "en",
  //       bp_number: "CzU1lM1yJtxv8ZQfn8GOq7OPrLYpfUPRQGjl0is1Svk=",
  //       newPhone: false,
  //       freeText: false,
  //     },
  //   },
  // },
  // {
  //   id: 12,
  //   data: {
  //     ndata: {
  //       session_id: "d7bc4896-b338-485b-9a6e-280f3cf4bb8e",
  //       message:
  //         '[{"text":"\\n Request Status : Completed\\n Request creation time : 2024/01/23 00:00\\n Note : ‫لم يتم الانتهاء من العزل الحراري للجدران‬\\n  <Links>Request</Links>"},{"text":"Would you like to contact our agents?"}]',
  //       conv_id: "b9f89c8d-d010-4a0e-9ef1-250da9cd5caa",
  //       chatby: "bot",
  //       channel: "web",
  //       ip_address: "10.128.31.201",
  //       action: "validate_uds_number_P5",
  //       timestamp: "var2",
  //       element: {
  //         Btns: {
  //           Buttons: [
  //             {
  //               name: "Exit",
  //               value: "Exit",
  //             },
  //             {
  //               name: "Start the conversation",
  //               value: "Start the conversation",
  //               Values: [
  //                 {
  //                   name: "full_name",
  //                 },
  //                 {
  //                   name: "mobile_number",
  //                 },
  //                 {
  //                   name: "contract_number",
  //                 },
  //                 {
  //                   name: "chat_transcript",
  //                   value:
  //                     " \nCustomer: {anonymous} \nBot:  Let's start, How can I help you? \nCustomer: Track Requests \nBot:  Choose the service \nCustomer: Electricity Connection Request \nBot:  Please enter request number \nCustomer: 242000036",
  //                 },
  //               ],
  //             },
  //           ],
  //         },
  //       },
  //       inputType: "Agent",
  //       Url: "https://slstage.sec.se.com.sa/",
  //       language: "en",
  //       bp_number: "var1",
  //       newPhone: false,
  //       freeText: false,
  //     },
  //   },
  // },
  {
    id: 14,
    data: {
      ndata: {
        session_id: "dcde7b79-86c5-4819-b083-e026dfe12692",
        message:
          '[{"text":"Please find the details as below :"},{"text":"We hope that we diligently serviced you, share your evaluation with us.\\nHave a nice day!"}]',
        conv_id: "0cb17cff-1845-482d-969f-92fd5f660b15",
        chatby: "bot",
        channel: "web",
        ip_address: "10.128.31.201",
        action: "get_account_information",
        timestamp: "var2",
        element: {
          AccNameParam: {
            Values: [
              {
                name: "contract_number",
                value: "30050740945",
              },
              {
                name: "property_name",
                value: "أبو خالد",
              },
              {
                name: "meter_number",
                value: "LYE2020830015321",
              },
              {
                name: "role",
                value: "Owner",
              },
            ],
          },
          feedbackBtn: {
            options: [
              {
                name: "Very satisfied",
                value: "5",
              },
              {
                name: "Satisfied",
                value: "4",
              },
              {
                name: "Netural",
                value: "3",
              },
              {
                name: "Dissatisfied",
                value: "2",
              },
              {
                name: "Very dissatisfied",
                value: "1",
              },
            ],
          },
        },
        inputType: "AccountInfoWithName",
        Url: "https://sec-chatbot-uat.sec.se.com.sa/SECApplication/",
        language: "en",
        bp_number: "var1",
        newPhone: false,
        freeText: false,
      },
    },
  },
  {
      id: 6,
      data: {
        ndata: {
          session_id: "be750eeb-6923-4608-9d04-7117d1e411d2",
          message: '[{"text":"Attach a picture for the report"}]',
          conv_id: "9945431f-f01c-43b7-aa32-12d6d99caa0a",
          chatby: "bot",
          channel: "web",
          ip_address: "10.128.31.201",
          action: "",
          timestamp:
            "iip/Xl6I/iPXO/0usVaq6bVJqJZGeOUHgh+8ZUwoQZyJPLkw3Fo8abNYqIleYa/q",
          element: {
            Btns: {
              Buttons: [
                {
                  name: "Attach the picture",
                  value: "Attach the picture",
                },
              ],
            },
          },
          inputType: "File",
          Url: "https://slstage.sec.se.com.sa/",
          language: "en",
          bp_number: "CzU1lM1yJtxv8ZQfn8GOq7OPrLYpfUPRQGjl0is1Svk=",
          newPhone: false,
          freeText: false,
        },
      },
    }
];
